import React from "react";

const LogoLogin = () => {
  return <h1>El Logo</h1>;
};
export default LogoLogin;
